import { Redirect } from 'react-router-dom';

import { useEntitlements } from 'providers/entitlements/EntitlementsProvider';

import { usePSLabs } from 'controllers/contexts/labsFeatures';
import type { EntitlementKey } from 'providers/entitlements/types';

interface RouteGuardProps {
  /** The Component to render if all checks pass */
  children: JSX.Element;

  /** A list of entitlements. Component will render if ANY entitlement check passes */
  entitlements?: EntitlementKey[];

  /** A LabsFlag that will control whether the entitlement is checked. Temporary workaround. */
  flag?: string;

  /** Route to redirect to if no check passes */
  redirectTo?: string;
}

/**
 * Guards the wrapped component. Provide an Entitlement, LabsFlag, etc and the
 * wrapped component will only render if at least one check passes.
 */
export const RouteGuard = ({
  children,
  entitlements,
  flag,
  redirectTo,
}: RouteGuardProps): JSX.Element => {
  const { isEntitledTo } = useEntitlements();
  const { hasLabsFlag } = usePSLabs();

  if (
    (flag ? hasLabsFlag(flag) : true) &&
    entitlements?.length &&
    !entitlements.some((entitlement) => isEntitledTo(entitlement))
  ) {
    return <Redirect to={redirectTo ?? '/'} />;
  }

  return children;
};
